module.exports = __webpack_public_path__ + "media/images/stamp_coupon-7c20648bc016544dbb55a6297c7ad5ed.svg";